import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseResponse } from 'src/app/model/response/base-response';
import { environment } from 'src/environments/environment';
import { Tickets, TicketsBaseResponse, TicketsRequest, TicketsRequestPublic } from './tickets';

@Injectable({
    providedIn: 'root'
})
export class TicketsService {

    private url: string = `${environment.apiUrl}/tickets`;
    constructor(
        private http: HttpClient,
    ) { }

    newTicket(request: TicketsRequest): Observable<TicketsBaseResponse> {
        return this.http.post<TicketsBaseResponse>(`${this.url}/new`, request);
    }

    newTicketPublic(request: TicketsRequestPublic): Observable<TicketsBaseResponse> {
        return this.http.post<TicketsBaseResponse>(`${this.url}/public/new`, request);
    }

    editTicket(codice: string, request: TicketsRequest): Observable<TicketsBaseResponse> {
        return this.http.put<TicketsBaseResponse>(`${this.url}/update/${codice}`, request);
    }

    getTicketByCodice(codice: string): Observable<TicketsBaseResponse> {
        return this.http.get<TicketsBaseResponse>(`${this.url}/get/single/${codice}`);
    }

    getTicketByTracking(codice: string): Observable<TicketsBaseResponse> {
        return this.http.get<TicketsBaseResponse>(`${this.url}/tracking/${codice}`);
    }

    deleteTicket(codice: string, deleteAttivita: boolean): Observable<BaseResponse> {
        return this.http.delete<BaseResponse>(`${this.url}/delete/${codice}?deleteAttivita=${deleteAttivita}`);
    }

    checkLock(codice: string): Observable<BaseResponse> {
        return this.http.get<BaseResponse>(`${this.url}/lock/check/${codice}`);
    }

    setLock(codice: string, username?: string): Observable<boolean> {
        let url = `${this.url}/lock/set/${codice}?`;
        if (username != null) {
            url = url + `username=${username}`;
        }
        return this.http.put<boolean>(url, null);
    }

    generateRapportino(codice: string) {
        return this.http.get<BaseResponse>(
            `${this.url}/files/rapportino/${codice}`,
            {
                // responseType: 'arraybuffer'
                responseType: 'blob' as 'json'
            }
        );
    }

}